export default __webpack_public_path__ + "static/media/alyssa_yoon.139917da.jpg";